import ApiService from "../../Services/ApiService";

export default {
    state: {
        earnings: [],
    },

    getters: {
        getPastAndImminentEarnings(state) {
            return state.earnings;
        },
    },

    mutations: {
        setPastAndImminentEarnings(state, payload) {
            state.earnings = payload;
        },
    },

    actions: {
        async loadPastAndImminentEarnings({ commit }, user_id = 0) {
            const earnings = (await ApiService.getPastAndImminentEarnings(user_id)).data;

            commit("setPastAndImminentEarnings", earnings);
        }
    }
}
